// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
// console.log('Vite ⚡️ Rails')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

// console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

import { createApp } from 'vue'
import App from '../components/App.vue'
import router from '../router.js'

// Apply stored theme immediately to avoid flash on load.
// "light" maps to our custom m2d2 theme; "dark" to DaisyUI built-in dark.
// Removing the attribute lets DaisyUI's default (m2d2) + media-query dark handle system.
;(function applyStoredTheme() {
  const stored = localStorage.getItem('m2d2-theme');
  if (stored === 'light') {
    document.documentElement.setAttribute('data-theme', 'm2d2');
  } else if (stored === 'dark') {
    document.documentElement.setAttribute('data-theme', 'dark');
  } else {
    document.documentElement.removeAttribute('data-theme');
  }
}());

document.addEventListener('DOMContentLoaded', () => {
  if (!document.getElementById('app')) return;

  const app = createApp(App);
  app.use(router);
  app.mount('#app');
});